module.exports = __webpack_public_path__ + "img/visitor.9441c916.svg";